import { Component } from '@angular/core';
import { NavController, LoadingController, ViewController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'page-configuration-integrations-popup',
  templateUrl: 'configuration-integrations-popup.html'
})

export class ConfigurationIntegrationsPopupPage {

  msg: any;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController) {

    this.start();

  }

  async start() {
    this.msg = '<link rel="stylesheet" type="text/css" href="https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/scripts%2Freservations%2Fmct-reservations.css?alt=media&token=25c9ced8-e293-4dac-af15-5ecab61b3bd1">';
    this.msg += '<div id="mct_script_reservations"></div>';
    this.msg += "<script> var public_uid = '" + this.globals.public_key + "';";
    this.msg += "var lang = 'es'; //Language form </script>";
    this.msg += '<script charset="UTF-8" src="https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/scripts%2Freservations%2Fmct-reservations.js?alt=media&token=bf47e5e4-48e1-4d5c-ba4a-0d565f565326"></script>';
  }

  close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-integrations/configuration-integrations-popup/configuration-integrations-popup.ts